module.exports = __webpack_public_path__ + "static/img/10019 (6).4e9f1ef.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10019 (6).webp
// module id = KGYF
// module chunks = 14